import { useEffect, useState } from 'react';

import socket from '@/services/socket';

import { useAppSelector } from './redux';

export const useLessonCount = () => {
  const user = useAppSelector(store => store.auth.user);
  const [lessonCount, setLessonCount] = useState<number>(0);

  useEffect(() => {
    if (user) {
      socket.on('learner-user-count-lesson', (count: number) => {
        setLessonCount(count);
      });
    }
  }, [user]);

  return {
    lessonCount
  };
};
